import {
  SET_STEP,
  SET_TOKEN,
  SET_GOOGLE_TOKEN,
  SET_APPLE_TOKEN,
  SET_REFERRAL_CODE,
} from './actions/types'

const INITIAL_STATE = {
  step: 1,
  token: 1,
  googleToken: null,
  appleToken: null,
  referralCode: '',
}

function setToken(state, action) {
  return {
    ...state,
    token: action.payload.token,
  }
}

function setStep(state, action) {
  return {
    ...state,
    step: action.payload.step,
  }
}

function setGoogleToken(state, action) {
  return {
    ...state,
    googleToken: action.payload.googleToken,
    appleToken: null,
  }
}

function setAppleToken(state, action) {
  return {
    ...state,
    googleToken: null,
    appleToken: action.payload.appleToken,
  }
}

function setReferralCode(state, action) {
  return {
    ...state,
    referralCode: action.payload.referralCode,
  }
}

function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_STEP:
      return setStep(state, action)
    case SET_TOKEN:
      return setToken(state, action)
    case SET_GOOGLE_TOKEN:
      return setGoogleToken(state, action)
    case SET_APPLE_TOKEN:
      return setAppleToken(state, action)
    case SET_REFERRAL_CODE:
      return setReferralCode(state, action)
    default:
      break
  }

  return state
}

export default reducer
